import React from 'react';

import PropTypes from 'prop-types';
import {
    connect,
} from 'react-redux';

import {
    tripSelectors,
} from 'wanderu-ducks-trips';

import DurationComponent from '../../components/SearchResult/Duration/Duration';

function Duration(props) {
    return (
        <DurationComponent {...props} />
    );
}

Duration.propTypes = {
    className: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
    const {
        tripId,
    } = ownProps;

    return tripSelectors.selectTripDuration(state, tripId);
}

export {
    Duration,
};
export default connect(mapStateToProps)(Duration);
